import React from 'react';
import _ from 'lodash';

import {formatDate} from 'utils/datetime';

import Table from 'components/Table';
import {PartialTenantInfo} from 'components/TenantInfo';
import ClickIconWithNoPropagation from 'components/ClickIconWithNoPropagation';
import BookingSetStatusTag from 'components/BookingSetStatusTag';
import DepositSummaryStatusTag from 'components/DepositSummaryStatusTag';

import {Paginator} from './components';

import './styles.css';

const BookingSetRow = ({
  bookingSet: {
    id,
    tenant,
    startDate,
    endDate,
    bookings,
    rooms,
    createdBy,
    status,
    depositSummaryStatus,
    source,
    stayDuration
  },
  redirectToBookingSetDetail,
  redirectToBookingDetail
}) => {
  return (
    <Table.Row onClick={() => redirectToBookingSetDetail({bookingSetId: id})}>
      <Table.Cell className="booker colab-bold">
        <PartialTenantInfo tenant={tenant} />
      </Table.Cell>
      <Table.Cell className="bookings">
        <div className="bookingLinks colab-bold colab-centered-v">
          {bookings.map(booking => (
            <React.Fragment key={booking.id}>
              <ClickIconWithNoPropagation
                onClick={() =>
                  redirectToBookingDetail({bookingId: booking.id})
                }>
                <div>{booking.id}</div>
              </ClickIconWithNoPropagation>

              <p className="arrow"> → </p>
            </React.Fragment>
          ))}
        </div>
      </Table.Cell>
      <Table.Cell className="status">
        <BookingSetStatusTag status={status} />
      </Table.Cell>
      <Table.Cell className="depositSummaryStatus">
        <DepositSummaryStatusTag status={depositSummaryStatus} />
      </Table.Cell>
      <Table.Cell className="rooms">{rooms}</Table.Cell>
      <Table.Cell className="startDate">{formatDate(startDate)}</Table.Cell>
      <Table.Cell className="endDate">{formatDate(endDate)}</Table.Cell>
      <Table.Cell className="createdBy">{createdBy || source}</Table.Cell>
      <Table.Cell className="lengthOfStay">{stayDuration}</Table.Cell>
    </Table.Row>
  );
};

const BookingSetTable = ({
  exportBookingSetsCsvInBackground,
  exportingBookingSetsCsv,
  bookingSets,
  pagination,
  onPageChange,
  sort,
  onSort,
  redirectToBookingSetDetail,
  redirectToBookingDetail
}) => {
  const columnsMap = [
    {className: 'booker', heading: 'Booker', sortField: 'tenant'},
    {className: 'bookings', heading: 'Bookings'},
    {className: 'status', heading: 'Status', sortField: 'status'},
    {className: 'depositSummaryStatus', heading: 'Deposit status'},
    {className: 'rooms', heading: 'Rooms'},
    {className: 'startDate', heading: 'Start Date', sortField: 'start'},
    {className: 'endDate', heading: 'End Date', sortField: 'end'},
    {className: 'createdBy', heading: 'Created By'},
    {
      className: 'lengthOfStay',
      heading: 'Length of stay',
      sortField: 'stayDuration'
    }
  ];

  return (
    <div className="BookingSetTable">
      <div className="BookingSetTable__container">
        <div className="BookingSetTable__header">
          <Table>
            <Table.Header>
              {columnsMap.map(column => (
                <Table.HeaderItem
                  key={column.heading}
                  className={column.className}
                  sortDirection={
                    column.sortField === sort.field ? sort.direction : null
                  }
                  onSort={() => column.sortField && onSort(column.sortField)}
                  heading={column.heading}
                />
              ))}
            </Table.Header>
          </Table>
        </div>
        <div className="BookingSetTable__content">
          <Table>
            <Table.Body>
              {bookingSets.map((bookingSet, index) => (
                <BookingSetRow
                  key={index}
                  bookingSet={bookingSet}
                  redirectToBookingSetDetail={redirectToBookingSetDetail}
                  redirectToBookingDetail={redirectToBookingDetail}
                />
              ))}
            </Table.Body>
          </Table>
        </div>
      </div>
      <Paginator
        pagination={pagination}
        onPageChange={onPageChange}
        exportBookingSetsCsvInBackground={exportBookingSetsCsvInBackground}
        exportingBookingSetsCsv={exportingBookingSetsCsv}
        disableExporting={_.isEmpty(bookingSets)}
      />
    </div>
  );
};

export default BookingSetTable;
